// extracted by mini-css-extract-plugin
export default {"quizCard":"style_quizCard__IOKzH","quizLogo":"style_quizLogo__8W6Oq"};